const MemoryIQView = () => import(/* webpackChunkName: "memoryiq" */ './views/MemoryIQView');

export default [
    {
        path: '/memoryiq',
        name: 'MemoryIQView',
        component: MemoryIQView
    }
];
